/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAppInfo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8.293 2.293A1 1 0 0 1 9 2h12a1 1 0 0 1 1 1v12a1 1 0 0 1-.293.707l-6 6A1 1 0 0 1 15 22h-2v-2h1V10H4v1H2V9a1 1 0 0 1 .293-.707zM5.414 8h9.172l4-4H9.414zM20 5.414l-4 4v9.172l4-4z" />
        <path d="M7 22a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm.6-2H6.4v-3.8h1.2zm0-4.9H6.4V14h1.2z" />
      </g>
    </g>
  </Icon>
);
export { SvgAppInfo as AppInfo };
